/**
 * block
 * We'll be supporting these block types:
 * - text
 * - image
 * - embed
 * - bookmark
 * {
 * id : '',
 * owner : '',
 * type : '',
 * content: {},
 * source : {}
 * }
 */
import api from '@/lib/api.js';
import $ from 'jquery';
import _ from 'lodash';
import nanoid from 'nanoid';
import blockSpec from '@/lib/spec.js';

import textBlockActions from '@/lib/text-block-actions.js';
import generalBlockActions from '@/lib/general-block-actions.js';
import onboardingBlockActions from '@/lib/onboarding-block-actions.js';

var store = {
	namespaced: true,
	state: {
		blocks: []
	},

	getters: {
		blocks: function(state) {
			return state.blocks;
		},
		block: function(state) {
			return id => {
				let n = false;
				state.blocks.map(block => {
					if (block._id === id) {
						n = block;
					}
				});
				return n;
			};
		},
		rootBlock: function(state) {
			let blocks = state.blocks;
			let rootBlock = null;
			for (let i = 0; i < blocks.length; i++) {
				if (blocks[i].root === true) {
					rootBlock = blocks[i];
					break;
				}
			}
			return rootBlock;
		},
		parentBlock: function(state) {
			let blocks = state.blocks;
			return blockId => {
				let parentBlock = null;
				for (let i = 0; i < blocks.length; i++) {
					if (blocks[i]._id === blockId) {
						parentBlock = blocks[i];
						break;
					}
				}
				return parentBlock;
			};
		}
	},

	mutations: {
		ADD_BLOCK: function(state, block) {
			state.blocks.push(block);
		},
		DELETE_BLOCK: function(state, removalBlock) {
			state.blocks = state.blocks.filter(block => {
				if (removalBlock._id === block._id) {
					return false;
				} else {
					return true;
				}
			});
		},
		ADD_BLOCKS: function(state, blocksArray) {
			state.blocks = state.blocks.concat(blocksArray);
		},
		SET_BLOCKS: function(state, blocks) {
			state.blocks = blocks;
		},
		UPDATE_BLOCK: function(state, block) {
			state.blocks = state.blocks.map(b => {
				if (b._id === block._id) {
					b = block;
				}
				return b;
			});
		},
		DELETE_BLOCKS: function(state, blocksArray) {
			state.blocks = state.blocks.filter(block => {
				if (blocksArray.includes(block._id)) {
					return false;
				} else {
					return true;
				}
			});
		}
	},

	actions: {
		/**
		 * Wrapper functions
		 * Functions which wrap core low level actions
		 */

		async init(store) {
			await store.dispatch('getBlocks');
			let blocks = store.state.blocks || [];
			let res = true;
			if (blocks.length === 0) {
				let user = store.rootGetters['user/user'];
				let block = blockSpec.createBlock({
					owner: user._id,
					content: {},
					source: {},
					blocks: [],
					parent: null,
					root: true,
					archive: false
				});
				res = await store.dispatch('addBlock', block);
				await api.blocks.addBlock(block);
			}
			return res;
		},

		/**
		 * Low level actions that mutate the state
		 */
		addBlock(store, block) {
			store.commit('ADD_BLOCK', block);
		},
		bulkAddBlocks(store, blocksData) {
			for (let i = 0; i < blocksData.length; i++) {
				store.commit('ADD_BLOCK', blocksData[i]);
			}
		},
		deleteBlock(store, block) {
			store.commit('DELETE_BLOCK', block);
		},
		bulkDeleteBlocks(store, blocksData) {
			for (let i = 0; i < blocksData.length; i++) {
				store.commit('DELETE_BLOCK', blocksData[i]);
			}
		},
		updateBlock(store, block) {
			store.commit('UPDATE_BLOCK', block);
		},
		bulkUpdateBlocks(store, blocksData) {
			for (let i = 0; i < blocksData.length; i++) {
				store.commit('UPDATE_BLOCK', blocksData[i]);
			}
		},

		getBlocks: generalBlockActions.getBlocks,

		addTextBlocks: textBlockActions.addTextBlocks,

		addPastedTextBlocks: textBlockActions.addPastedTextBlocks,

		updateTextBlock: textBlockActions.updateTextBlock,

		addTextBlockToParent: textBlockActions.addTextBlockToParent,

		//createBlock: generalBlockActions.createBlock,

		//createBlocks: generalBlockActions.createBlocks,

		removeBlocksWrapper: generalBlockActions.removeBlocksWrapper,

		updatePosition: generalBlockActions.updatePosition,

		dropInBlock: generalBlockActions.dropInBlock,

		groupBlocks: generalBlockActions.groupBlocks,

		removeTextBlock: textBlockActions.removeTextBlock,

		breakTextBlock: textBlockActions.breakTextBlock,

		async refresh(store) {
			await store.dispatch('getBlocks');
		},

		notesToBlocks: onboardingBlockActions.notesToBlocks,

		convertNotes: onboardingBlockActions.convertNotes,

		insertOnboardingBlocks: onboardingBlockActions.insertOnboardingBlocks,

		setNextTextBlockFocus: textBlockActions.setNextTextBlockFocus,

		setPreviousTextBlockFocus: textBlockActions.setPreviousTextBlockFocus,

		copyBlocks: generalBlockActions.copyBlocks
	}
};

export default store;
